import { useMemo } from 'react';
import { SelectionMode } from '@xyflow/react';
import type { ToolKind } from '../../components/shell/toolbar/use-canvas-tool';

export interface PointerModeProps {
  panOnDrag: boolean | number[];
  selectionOnDrag: boolean;
  selectionKeyCode?: string;
  selectionMode: SelectionMode;
  panActivationKeyCode: string;
}

/**
 * Maps a tool kind to the ReactFlow pan/selection props for that mode.
 *
 * Select:    left-drag = pan; Shift+drag = rubber-band; Space = pan override
 * Hand:      left-drag = pan; no rubber-band
 * Placement: no drag pan or selection (pointer is for placing nodes)
 */
export function resolvePointerMode(kind: ToolKind): PointerModeProps {
  switch (kind) {
    case 'select':
      return {
        panOnDrag: true,
        selectionOnDrag: true,
        selectionKeyCode: 'Shift',
        selectionMode: SelectionMode.Partial,
        panActivationKeyCode: 'Space',
      };
    case 'hand':
      return {
        panOnDrag: true,
        selectionOnDrag: false,
        selectionMode: SelectionMode.Partial,
        panActivationKeyCode: 'Space',
      };
    default:
      return {
        panOnDrag: false,
        selectionOnDrag: false,
        selectionMode: SelectionMode.Partial,
        panActivationKeyCode: 'Space',
      };
  }
}

export function usePointerMode(kind: ToolKind): PointerModeProps {
  return useMemo(() => resolvePointerMode(kind), [kind]);
}
